<template>
  <div
    class="layout-builder-layout-placeholder-card"
    :class="{ deleted: isDeleted }"
  >
    <div
      v-if="isDeleted"
      class="layout-builder-layout-placeholder-card-title"
    >
      {{ title }}
    </div>

    <template v-else>
      <div
        v-for="i in PLACEHOLDER_SAMPLES"
        :key="i"
        class="layout-builder-layout-placeholder-card-item"
      >
        <div class="layout-builder-layout-placeholder-card-item-top">
          <div class="layout-builder-layout-placeholder-card-item-top-line" />
          <div class="layout-builder-layout-placeholder-card-item-top-square" />
        </div>
        <div class="layout-builder-layout-placeholder-card-item-bottom">
          <div class="layout-builder-layout-placeholder-card-item-bottom-line" />
          <div class="layout-builder-layout-placeholder-card-item-bottom-square" />
        </div>
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  computed,
  toRefs,
  getCurrentInstance,
} from '@vue/composition-api';

export default defineComponent({
  name: 'LayoutBuilderLayoutPlaceholderCard',
  props: {
    isDeleted: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { isDeleted } = toRefs(props);
    const vm = getCurrentInstance()!;

    const PLACEHOLDER_SAMPLES = 50;

    const title = computed(() => isDeleted.value
      ? vm.proxy.$t('hitl.modules.layout-builder.layout.placeholder.deleted-card-message')
      : '',
    );

    return {
      title,
      PLACEHOLDER_SAMPLES,
    };
  },
});
</script>

<style lang="scss" scoped>
@use '@/styles' as *;
@import "../../../styles/index";

.layout-builder-layout-placeholder-card {
  @include placeholder;

  $root: &;

  width: 100%;
  height: 100%;
  gap: var(--s-6);

  &.deleted {
    background-color: var(--or-c-error-opacity-0-16);

    #{$root}-title {
      @include text-overflow;

      color: var(--or-c-outline);
    }
  }

  &-item {
    display: flex;
    flex-direction: column;
    gap: var(--s-4);

    > * {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
    }

    &-top {
      &-line {
        @include placeholder-line-primary;

        flex: 0 1 6.5625rem;
      }

      &-square {
        @include placeholder-line-secondary;

        flex: 0 0 1.125rem;
      }
    }

    &-bottom {
      gap: 3.375rem;

      &-line {
        @include placeholder-line-secondary;

        flex: 1 1 auto;
      }

      &-square {
        @include placeholder-line-secondary;

        flex: 0 0 1.125rem;
      }
    }
  }
}
</style>
